import LocalizeTextField from './LocalizeTextField';

export default class ControllerTextField extends LocalizeTextField {
  fitSize() {
    super.fitSize(true, true);
  }
}
